import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql, compose } from 'react-apollo'
import queryString from 'query-string'
import {
  companyFragment,
  companyEmployeeListFragment,
  viewerFragment,
  userErrorsFragment,
} from 'fragments'
import { setCompany } from 'modules/company'
import { setUIState, containerIds } from 'modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import BusinessLayout from 'components/layouts/BusinessLayout'
import InvitationForm from 'components/organisms/InvitationForm'
import PendingEmployeeList from 'components/organisms/PendingEmployeeList'
import EmployeeList from 'components/business/EmployeeList'
import { bindActionCreators } from 'redux'

class EmployeeListContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const { actions, data } = this.props
    actions.setCompany(data.company)
    actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
      showPendingList: true,
      isSendButton: false,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, data } = this.props
    const { company } = data
    if (
      prevProps.data.company.employees.results !== company.employees.results
    ) {
      actions.setCompany(company)
    }
  }

  render() {
    const {
      company,
      actions,
      ui,
      data,
      config,
      updateCompanyEmployee,
      inviteCompanyEmployee,
      createCompanyEmployeeInvitationList,
      bulkInviteCompanyEmployee,
    } = this.props

    return (
      <BusinessLayout
        title={i18n.t('server.business.employees.title')}
        description={i18n.t('server.business.employees.description')}
        {...this.props}
      >
        <div className="container">
          <h1 className="business__title">
            {i18n.t('page.employee.sectionTitle')}
          </h1>
        </div>
        <div className="business-container container">
          <InvitationForm
            config={config}
            company={company}
            updateCompanyEmployee={updateCompanyEmployee}
            inviteCompanyEmployee={inviteCompanyEmployee}
            createCompanyEmployeeInvitationList={
              createCompanyEmployeeInvitationList
            }
            bulkInviteCompanyEmployee={bulkInviteCompanyEmployee}
            actions={actions}
            ui={ui}
          />
          {ui.showPendingList ? (
            <PendingEmployeeList {...this.props} />
          ) : (
            <EmployeeList {...this.props} />
          )}
        </div>
        {ui.successfulMsg && (
          <p className="business-reservation-setting__feedback-done">
            {ui.successfulMsg}
          </p>
        )}
        {ui.failureMsg && (
          <p className="business-reservation-setting__feedback-error">
            {ui.failureMsg}
          </p>
        )}
      </BusinessLayout>
    )
  }
}

const bulkInviteCompanyEmployee = gql`
  mutation BulkInviteCompanyEmployee($input: BulkInviteCompanyEmployeeInput!) {
    bulkInviteCompanyEmployee(input: $input) {
      userErrors {
        resource
        field
        message
      }
    }
  }
`

const createCompanyEmployeeInvitationList = gql`
  mutation createCompanyEmployeeInvitationList(
    $input: CreateCompanyEmployeeInvitationListInput!
  ) {
    createCompanyEmployeeInvitationList(input: $input) {
      userErrors {
        field
        message
        resource
      }
    }
  }
`

const updateCompanyEmployee = gql`
  mutation updateCompanyEmployee($input: UpdateCompanyEmployeeInput!, $page: Int!, $perPage: Int!) {
    updateCompanyEmployee(input: $input) {
      company {
        ${companyEmployeeListFragment}
      }
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const inviteCompanyEmployee = gql`
  mutation inviteCompanyEmployee($input: InviteCompanyEmployeeInput!) {
    inviteCompanyEmployee(input: $input) {
      company {
        id
        username
      }
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const deleteCompanyEmployee = gql`
  mutation deleteCompanyEmployee($input: DeleteCompanyEmployeeInput!, $page: Int!, $perPage: Int!) {
    deleteCompanyEmployee(input: $input) {
      company {
        ${companyEmployeeListFragment}
      }
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const withMutation = compose(
  graphql(bulkInviteCompanyEmployee, {
    props: ({ mutate }) => ({
      bulkInviteCompanyEmployee: input => mutate({ variables: { input } }),
    }),
  }),
  graphql(createCompanyEmployeeInvitationList, {
    props: ({ mutate }) => ({
      createCompanyEmployeeInvitationList: input =>
        mutate({ variables: { input } }),
    }),
  }),
  graphql(inviteCompanyEmployee, {
    props: ({ mutate }) => ({
      inviteCompanyEmployee: input => mutate({ variables: { input } }),
    }),
  }),
  graphql(updateCompanyEmployee, {
    props: ({ mutate }) => ({
      updateCompanyEmployee: (input, page, perPage) =>
        mutate({ variables: { input, page, perPage } }),
    }),
  }),
  graphql(deleteCompanyEmployee, {
    props: ({ mutate }) => ({
      deleteCompanyEmployee: (input, page, perPage) =>
        mutate({ variables: { input, page, perPage } }),
    }),
  }),
)(EmployeeListContainer)

const withData = graphql(
  gql`
  query BusinessEmployeeListContainer($username: String!, $page: Int!, $perPage: Int!) {
    company(username: $username) {
      ${companyEmployeeListFragment}
    }
    viewer {
      ${viewerFragment}
      companies {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
        page: parseInt(queryString.parse(props.location.search).page || 1, 10),
        perPage: 20,
      },
    }),
  },
)(withMutation)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState, setCompany }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)
